/**
 * Determines the correct English indefinite article ("a" or "an") to precede a number,
 * based on the leading spoken sound of that number (e.g. eight, eleven, eighteen, eighty,
 * eight hundred all start with a vowel sound and take "an").
 *
 * Only the leading 1-3 significant digits (the first "group" spoken in English number
 * naming) determine the leading word's sound, so this works for any magnitude without
 * needing a full number-to-words conversion.
 */
export const getIndefiniteArticle = (value: number): 'a' | 'an' => {
  const digits = Math.abs(Math.trunc(value)).toString();
  const groupLength = ((digits.length - 1) % 3) + 1;
  const leadingGroup = Number(digits.slice(0, groupLength));

  const hundreds = Math.floor(leadingGroup / 100);
  if (hundreds > 0) return hundreds === 8 ? 'an' : 'a';

  if (leadingGroup >= 11 && leadingGroup <= 19) {
    return leadingGroup === 11 || leadingGroup === 18 ? 'an' : 'a';
  }

  const tens = Math.floor(leadingGroup / 10);
  if (tens > 0) return tens === 8 ? 'an' : 'a';

  return leadingGroup === 8 ? 'an' : 'a';
};
